/**
 * DbCityPicker 样式定义
 */

import { StyleSheet } from 'react-native';

/** 每个选项的高度 */
export const ITEM_HEIGHT = 44;

export const styles = StyleSheet.create({
  // Modal 遮罩层容器
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  // 背景遮罩（可点击关闭）
  backdrop: {
    flex: 1,
  },

  // 弹窗内容容器
  container: {
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    paddingBottom: 34,
  },

  // 头部
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    height: 50,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#EEEEEE',
  },

  title: {
    fontSize: 17,
    fontWeight: '600',
    color: '#333333',
  },

  // 按钮
  button: {
    paddingVertical: 8,
    paddingHorizontal: 4,
  },

  cancelButton: {
    fontSize: 16,
    color: '#999999',
  },

  confirmButton: {
    fontSize: 16,
    color: '#007AFF',
    fontWeight: '500',
  },

  // Picker 容器
  pickerContainer: {
    flexDirection: 'row',
    height: ITEM_HEIGHT * 5,
  },

  // 滚轮列
  wheelColumn: {
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
  },

  // 选中行高亮
  selectedHighlight: {
    position: 'absolute',
    top: ITEM_HEIGHT * 2,
    left: 0,
    right: 0,
    height: ITEM_HEIGHT,
    backgroundColor: '#F5F5F5',
    borderTopWidth: StyleSheet.hairlineWidth,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderColor: '#E0E0E0',
    zIndex: 0,
  },

  // 滚轮选项
  wheelItem: {
    height: ITEM_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },

  // 滚轮选项文字
  wheelItemText: {
    fontSize: 15,
    color: '#999999',
  },

  // 选中的滚轮选项文字
  wheelItemTextSelected: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333333',
  },
});
